var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThankYou(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 369,
    height: 211,
    viewBox: "0 0 369 211",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M304.984 75.8273V0H321.016V33.4336H322.016L349.303 0H368.519L340.38 33.952L368.853 75.8273H349.674L328.903 44.6522L321.016 54.2787V75.8273H304.984Z",
    fill: "#AEE4E6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M291.739 0V75.8273H277.891L244.902 28.102H244.347V75.8273H228.315V0H242.384L275.115 47.6882H275.781V0H291.739Z",
    fill: "#AEE4E6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M163.392 75.8273H146.212L172.389 0H193.049L219.188 75.8273H202.009L183.015 17.3277H182.422L163.392 75.8273ZM162.318 46.0221H202.897V58.5366H162.318V46.0221Z",
    fill: "#AEE4E6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M72.5322 75.8273V0H88.5641V31.2861H121.109V0H137.104V75.8273H121.109V44.5041H88.5641V75.8273H72.5322Z",
    fill: "#AEE4E6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 13.2179V0H62.2761V13.2179H39.0614V75.8273H23.2147V13.2179H0Z",
    fill: "#AEE4E6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M321.01 95.8777H344.988V169.529C344.988 177.799 343.013 185.035 339.063 191.237C335.15 197.439 329.667 202.276 322.616 205.746C315.565 209.179 307.35 210.896 297.973 210.896C288.559 210.896 280.326 209.179 273.275 205.746C266.224 202.276 260.741 197.439 256.828 191.237C252.915 185.035 250.958 177.799 250.958 169.529V95.8777H274.936V167.48C274.936 171.8 275.878 175.639 277.761 178.999C279.68 182.358 282.375 184.998 285.846 186.918C289.316 188.838 293.358 189.797 297.973 189.797C302.625 189.797 306.667 188.838 310.101 186.918C313.571 184.998 316.248 182.358 318.131 178.999C320.05 175.639 321.01 171.8 321.01 167.48V95.8777Z",
    fill: "#AEE4E6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1865 95.8777H43.0445L68.9056 144.72H70.0131L95.8743 95.8777H122.732L81.3655 169.197V209.29H57.5533V169.197L16.1865 95.8777Z",
    fill: "#AEE4E6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M129 162.5H152V203.5H165V162.5H188V152H129V162.5Z",
    fill: "white",
    stroke: "#AEE4E6"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M172.5 169.5V175H179.5V203.5H188V166.5L172.5 169.5Z",
    fill: "#AEE4E6"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M193.5 173.5V179.5L201.5 181.5V174H220.5V178L195.414 192.964C193.297 194.227 192 196.51 192 198.975V203.5H224C227.314 203.5 230 200.814 230 197.5V193L223 190.5V196.5H204.5L225.655 183.548C227.733 182.276 229 180.014 229 177.578V173.5C229 169.634 225.866 166.5 222 166.5H200.5C196.634 166.5 193.5 169.634 193.5 173.5Z",
    fill: "#AEE4E6"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M172.5 169.5V175H179.5V203.5H188V166.5L172.5 169.5Z",
    stroke: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M193.5 173.5V179.5L201.5 181.5V174H220.5V178L195.414 192.964C193.297 194.227 192 196.51 192 198.975V203.5H224C227.314 203.5 230 200.814 230 197.5V193L223 190.5V196.5H204.5L225.655 183.548C227.733 182.276 229 180.014 229 177.578V173.5C229 169.634 225.866 166.5 222 166.5H200.5C196.634 166.5 193.5 169.634 193.5 173.5Z",
    stroke: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M128.123 138.492H152.805C153.341 136.282 154.018 134.224 154.837 132.316C157.237 126.815 160.597 122.643 164.916 119.801C169.235 116.958 174.293 115.537 180.089 115.537C185.885 115.537 190.943 116.958 195.263 119.801C199.582 122.643 202.923 126.815 205.286 132.316C206.118 134.224 206.806 136.282 207.35 138.492H232.047C230.918 132.012 228.957 126.188 226.163 121.019C221.511 112.343 215.162 105.735 207.113 101.194C199.102 96.616 190.094 94.3271 180.089 94.3271C170.011 94.3271 160.966 96.616 152.955 101.194C144.943 105.735 138.612 112.343 133.96 121.019C131.189 126.188 129.243 132.012 128.123 138.492Z",
    fill: "#AEE4E6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThankYou);
export default __webpack_public_path__ + "static/media/thank-you.c05aa678b1d29a8627d2f5b9ca69576d.svg";
export { ForwardRef as ReactComponent };